const USER_ID_KEY = "ahavibes_user_id";
const EMAIL_KEY = "ahavibes_verified_email";
const SUBSCRIBER_KEY = "ahavibes_is_subscriber";

export function getStoredUserId() {
  try {
    return localStorage.getItem(USER_ID_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function setStoredUserId(userId) {
  try {
    const id = String(userId || "").trim();
    if (!id) {
      localStorage.removeItem(USER_ID_KEY);
      return;
    }
    localStorage.setItem(USER_ID_KEY, id);
  } catch (_) {
    /* ignore */
  }
}

/** History list cache — always keyed by user id when available. */
export function historyCacheKeyForUser(userId) {
  const id = String(userId || "").trim();
  return id ? `ahavibes_history_cache_uid_${id}` : "ahavibes_history_cache";
}

export function clearHistoryCacheForUser(userId) {
  try {
    localStorage.removeItem(historyCacheKeyForUser(userId));
  } catch (_) {
    /* ignore */
  }
}

/** Remove session identity from this browser (does not wipe other users' keyed caches). */
export function clearStoredSession() {
  try {
    localStorage.removeItem(USER_ID_KEY);
    localStorage.removeItem(EMAIL_KEY);
    localStorage.removeItem(SUBSCRIBER_KEY);
  } catch (_) {
    /* ignore */
  }
}

export { USER_ID_KEY, EMAIL_KEY, SUBSCRIBER_KEY };
